import React from 'react';
import { questionsApi } from '../api/questionsApi';
import type { QuestionTypeOption, InputFormatOption } from '../types';

export function useQuestionTypes(): {
  questionTypes: QuestionTypeOption[];
  inputFormats: InputFormatOption[];
  isLoading: boolean;
  error: Error | null;
} {
  const [questionTypes, setQuestionTypes] = React.useState<QuestionTypeOption[]>([]);
  const [inputFormats, setInputFormats] = React.useState<InputFormatOption[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<Error | null>(null);

  React.useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const [typesRes, formatsRes] = await Promise.all([
          questionsApi.listQuestionTypes(),
          questionsApi.listInputFormats(),
        ]);
        if (!cancelled) {
          setQuestionTypes(typesRes.questionTypes);
          setInputFormats(formatsRes.inputFormats);
        }
      } catch (err) {
        if (!cancelled) setError(err as Error);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return { questionTypes, inputFormats, isLoading, error };
}
